import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { PostServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import printJS from "print-js";
// import "./printStyles.css"; 

const ViewTempMaster = () => {


  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [prTemplateHeaderData, setTemplateHeaderData] = useState({});
  const [prTemplateTableData, setTemplateTableData] = useState([]);
  console.log('prTemplateTableData',prTemplateTableData);
  

  useEffect(() => {
    if (id) {
      fetchPrTemplateReport(id);
    }
  }, [id]);

  const fetchPrTemplateReport = async (id) => {
    setLoading(true);

    try {
      const response = await PostServiceCaller(
        `${API_URL}appraisal-template-master/${id}`
      );

      const header = response?.data?.data?.template;
      const tableData = response?.data?.data?.template_question;

      setTemplateHeaderData(header);
      setTemplateTableData(tableData);
    } catch (err) {
      console.error("Error fetching view Performance Evaluation report :", err);
    } finally {
      setLoading(false);
    }
  };

const renderResponse = (response) => {
  const answer = response?.EmployeeAnswer || "No answer provided";

  if (response?.QuestionType_202 === 1342) {
    // Long text / descriptive answer
    return (
      <div style={{ marginTop: "8px" }}>
        <textarea
          disabled
          className="w-100"
          value={answer}
          rows={Math.max(3, Math.ceil(answer.length / 100))} // Dynamic rows based on content
          style={{
            resize: "none",
            whiteSpace: "pre-wrap",
            overflowWrap: "break-word",
            lineHeight: "1.4",
            border: "1px solid #ccc",
            padding: "8px",
            borderRadius: "4px",
            backgroundColor: "#f9f9f9",
            fontFamily: "inherit",
            fontSize: "inherit",
            minHeight: "60px"
          }}
        />
      </div>
    );
  } else if (response?.QuestionType_202 === 1343) {
    // Radio buttons (single choice)
    const options = [
      response?.Option1,
      response?.Option2,
      response?.Option3,
      response?.Option4,
      response?.Option5,
    ].filter(Boolean);

    return options.length > 0 ? (
      <div style={{ marginTop: "8px" }}>
        {options.map((option, index) => (
          <div
            key={index}
            className="option-container"
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "8px",
              marginBottom: "6px",
              lineHeight: "1.4",
              wordBreak: "break-word",
              padding: "4px 0",
            }}
          >
            <input
              type="radio"
              name={`radio-Employee-${response?.LineNo}`}
              disabled
              style={{ 
                marginTop: "3px",
                flexShrink: 0
              }}
            />
            <span style={{ 
              flex: "1",
              wordBreak: "break-word",
              overflowWrap: "break-word"
            }}>
              {option}
            </span>
          </div>
        ))}
      </div>
    ) : (
      <div style={{ marginTop: "8px", fontStyle: "italic" }}>
        No options provided
      </div>
    );
  } else if (response?.QuestionType_202 === 1347) {
    // Checkboxes (multiple choice)
    const options = [
      response?.Option1,
      response?.Option2,
      response?.Option3,
      response?.Option4,
      response?.Option5,
    ].filter(Boolean);
    const selectedAnswers = answer.split(",").map(a => a.trim()) || [];

    return options.length > 0 ? (
      <div style={{ marginTop: "8px" }}>
        {options.map((option, index) => (
          <div
            key={index}
            className="option-container"
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "8px",
              marginBottom: "6px",
              lineHeight: "1.4",
              wordBreak: "break-word",
              padding: "4px 0",
            }}
          >
            <input
              type="checkbox"
              name={`checkbox-Employee-${response?.LineNo}`}
              disabled
              style={{ 
                marginTop: "3px",
                flexShrink: 0
              }}
              checked={selectedAnswers.includes(option)}
            />
            <span style={{ 
              flex: "1",
              wordBreak: "break-word",
              overflowWrap: "break-word"
            }}>
              {option}
            </span>
          </div>
        ))}
      </div>
    ) : (
      <div style={{ marginTop: "8px", fontStyle: "italic" }}>
        No options provided
      </div>
    );
  }

  return null;
};



const handlePrint = () => {
  printJS({
    printable: "Appraisal-Table",
    type: "html",
    targetStyles: ["*"],
    style: `
      @page {
        size: A4;
        margin: 10mm;
      }
      body {
        margin: 0;
        padding: 0;
        font-family: Arial, sans-serif;
        box-sizing: border-box;
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
      }
      #Appraisal-Table {
        width: 100%;
        max-width: 1000px;
        margin: 0 auto !important;
        padding: 0 10mm;
        box-sizing: border-box;
      }
      .container-fluid, .row {
        margin: 0 !important;
        padding: 0 !important;
      }
      table {
        border-collapse: collapse;
        width: 100%;
        margin-top: 10px;
        table-layout: fixed; /* Use fixed layout for better control */
        word-wrap: break-word;
      }
      thead th {
        background-color: #f2f2f2 !important;
        font-weight: 600;
        text-align: center;
        vertical-align: middle;
        padding: 8px;
        border: 1px solid #000;
      }
      tbody td {
        vertical-align: top !important;
        padding: 10px;
        word-wrap: break-word;
        white-space: normal !important;
        line-height: 1.4 !important;
        overflow-wrap: break-word;
        border: 1px solid #000;
        page-break-inside: avoid;
      }
      /* Specific column widths */
      tbody td:first-child {
        width: 60px; /* Fixed width for Q.No column */
        text-align: center;
        vertical-align: middle !important;
      }
      tbody td:last-child {
        width: auto; /* Remaining space for response */
        min-width: 200px;
      }
      h4, h5 {
        margin: 4px 0;
        font-weight: 600;
        page-break-inside: avoid;
      }
      .question-text {
        margin-bottom: 8px;
        page-break-inside: avoid;
      }
      textarea {
        border: 1px solid #ccc;
        resize: none;
        width: 100%;
        white-space: pre-wrap;
        overflow: hidden;
        font-family: inherit;
        font-size: inherit;
        background: white !important;
        min-height: 60px;
        box-sizing: border-box;
      }
      input[type="radio"], input[type="checkbox"] {
        margin-right: 8px;
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
      }
      .d-flex {
        display: block !important;
        margin-bottom: 4px;
        page-break-inside: avoid;
      }
      .text-end {
        text-align: right;
      }
      button, .custom-btn {
        display: none !important;
      }
      tr {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }
      /* Prevent page breaks inside important elements */
      .response-container {
        page-break-inside: avoid;
        break-inside: avoid;
      }
      /* Ensure proper spacing */
      .option-container {
        margin-bottom: 4px;
        padding: 2px 0;
      }
    `,
    documentTitle: prTemplateHeaderData?.Name || "Appraisal Template",
  });
};






  return (
    <>

      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2 mr-3">
            <div className="text-end">
              <div className="justify-content-center">
                <button className="custom-btn" onClick={handlePrint}>
                  <i className="bi bi-printer"></i> Print
                </button>
              </div>
            </div>
          </div>
         <div id="Appraisal-Table">
  <div className="row mt-1">
    <h4 className="text-bold">{prTemplateHeaderData?.Name}</h4>
  </div>
  <div className="row mx-2 mt-2">
    <Table bordered hover striped style={{ tableLayout: 'fixed' }}>
      <thead id="thcolor" className="text-center">
        <tr>
          <th style={{ width: '60px' }}>Q. No.</th>
          <th>Employee Response</th>
        </tr>
      </thead>
      <tbody>
        {prTemplateTableData.map((response, index) => (
          <tr key={index} style={{ pageBreakInside: 'avoid' }}>
            <td style={{ 
              width: '60px', 
              textAlign: 'center', 
              verticalAlign: 'middle',
              fontWeight: 'bold'
            }}>
              {response.LineNo}
            </td>
            <td>
              <div className="question-text">
                <h5 className="fw-600">
                  {response?.QuestionTitle}
                </h5>
              </div>
              <div className="response-container">
                {renderResponse(response)}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
</div>
          <div className="text-end">
              {/* <button className="custom-btn mt-4 me-2">Submit</button> */}

            
              <button
                type="button"
                className="btn-info me-2"
                onClick={() => navigate("/appraisal-template-masters")}
              >
                Cancel
              </button>

        </div>
        </div>
      </div>

    </>
  );
};

export default ViewTempMaster;
